import React, { useEffect, useState } from "react";
import { sort } from "ramda";
import { connect, ConnectedProps } from "react-redux";
import { getTypehint, setTypehint } from "../../store/actions";

interface IProps {
  searchArea: string;
  value?: string;
  className?: string;
  setValue?: (value: string) => void;
}

const mapStateToDispatch = (state: any) => ({
  typeHints: state.ui.typeHints
})

const mapDispatchToProps = (dispatch: any) => ({
  getTypeHintDispatch: (searchArea: string, value: string) => dispatch(
    getTypehint(searchArea, value)
  ),
  setTypeHintsDispatch: (typeHints: string[] | null) => dispatch(setTypehint(typeHints))
});

const connector = connect(mapStateToDispatch, mapDispatchToProps);

const HintedInput = ({
  searchArea,
  value,
  className,
  setValue,
  typeHints,
  getTypeHintDispatch,
  setTypeHintsDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [focused, setFocused] = useState(false);
  const [hints, setHints] = useState<string[]>([]);

  useEffect(() => {
    if (typeHints && typeHints.length) {
      setHints(typeHints);
    }

    // return () => setTypeHintsDispatch(null);
  }, [typeHints]);

  const handleClickOutside = (e: any) => {
    if (e.target.className.includes("input") || e.target.className.includes("tt-")) {
      return;
    }

    setFocused(false);
    if (!value) {
      setTypeHintsDispatch(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputChange = (newValue: string) => {
    if (setValue) {
      setValue(newValue);
    }

    if (newValue && newValue.length > 1) {
      getTypeHintDispatch(searchArea, newValue);
    } else {
      setTypeHintsDispatch(null);
    }
  }

  const handlePickHint = (e: any, hint: string) => {
    if (setValue) {
      setValue(hint);
      setHints([]);
    }
  }

  return (
    <span>
      <input
        type="text"
        className={`input ${className}`}
        value={value || ""}
        onChange={e => handleInputChange(e.target.value)}
        onFocus={() => setFocused(true)}
      />
      {focused && !!value && !!hints
      && hints.some(hint => new RegExp(value, "i").test(hint)) && <div className={"tt-menu"}>
        <div className={"tt-dataset tt-dataset-remote"}>
          {sort((h1, h2) => (h1.toLowerCase().startsWith(value.toLowerCase())
            ? -1 : (h2.toLowerCase().startsWith(value.toLowerCase()) ? 1 : 0)), hints
            .filter(hint => new RegExp(value, "i").test(hint))).slice(0, 5)
            .map((hint) => {
              const patternIndexes = Array.from(hint.matchAll(new RegExp(value, "gi")), m => m.index);
              return (<div className={"tt-suggestion tt-selectable"} onClick={e => handlePickHint(e, hint)}>
                {patternIndexes.map((index, i) => {
                  const currentIndex = i && ((patternIndexes[i - 1] || 0) + value.length);
                  return <>
                    {hint.slice(currentIndex, index)}
                    <strong className={"tt-highlight"}>{hint.slice(index, (index || 0) + value.length)}</strong>
                    {i === patternIndexes.length - 1 && (index || 0) + value.length < hint.length
                    && <>{hint.slice((index || 0) + value.length)}</>}
                  </>
                })}
              </div>)
            })
          }
        </div>
      </div>}
    </span>
  )
}

export default connector(HintedInput);
